/* tslint:disable */
/* eslint-disable */
// @ts-ignore
import * as Types from '../../../../global-graphql-types'

import { DocumentNode } from 'graphql'
import * as Apollo from '@apollo/client'
import * as ApolloReactHooks from 'utils/extendApolloHooks'
const defaultOptions = {} as const
export type MealPartsQueryVariables = Types.Exact<{ [key: string]: never }>

export type MealPartsQuery = {
  __typename: 'Query'
  upsellTypes: Array<{
    __typename: 'UpsellType'
    id: number
    name: string
    showInCatering: boolean
    cateringName: string
  }>
}

export const MealPartsQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MealPartsQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'upsellTypes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'showInCatering' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'cateringName' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode

/**
 * __useMealPartsQuery__
 *
 * To run a query within a React component, call `useMealPartsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMealPartsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMealPartsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMealPartsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    MealPartsQuery,
    MealPartsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<MealPartsQuery, MealPartsQueryVariables>(
    MealPartsQueryDocument,
    options
  )
}
export function useMealPartsQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    MealPartsQuery,
    MealPartsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<MealPartsQuery, MealPartsQueryVariables>(
    MealPartsQueryDocument,
    options
  )
}
export type MealPartsQueryHookResult = ReturnType<typeof useMealPartsQuery>
export type MealPartsQueryLazyQueryHookResult = ReturnType<
  typeof useMealPartsQueryLazyQuery
>
export type MealPartsQueryQueryResult = Apollo.QueryResult<
  MealPartsQuery,
  MealPartsQueryVariables
>
